





























import { Component, Vue } from 'vue-property-decorator'
import {
  pastWeek,
  pastMonth,
} from '@/utils/formValidate'
import {
  getDataOverView, //数据概览
  getTurnoverStatistics,
  getUserStatistics,
  getOrderStatistics,
  getTop,
  getStatisticsData, // 新增统一数据接口
} from '@/api/index'
// 组件
// 标题
import TitleIndex from './components/titleIndex.vue'
// 营业额统计
import TurnoverStatistics from './components/turnoverStatistics.vue'
// 用户统计
import UserStatistics from './components/userStatistics.vue'
// 订单统计
import OrderStatistics from './components/orderStatistics.vue'
// 排名
import Top from './components/top10.vue'
@Component({
  name: 'Dashboard',
  components: {
    TitleIndex,
    TurnoverStatistics,
    UserStatistics,
    OrderStatistics,
    Top,
  },
})
export default class extends Vue {
  private overviewData = {} as any
  private flag = 1
  private tateData = []
  private turnoverData = {} as any
  private userData = {}
  private orderData = {
    data: {},
  } as any
  private top10Data = {}
  created() {
    //this.init(this.flag)
    this.getTitleNum(1);
  }
  
  // 处理自定义日期选择
  handleCustomDate(begin: string, end: string) {
    try {
      console.log('自定义日期范围:', begin, 'to', end);
      this.tateData = [begin, end];
      this.flag = 3; // 设置为自定义标签
      this.fetchAllStatisticsData(begin, end);
    } catch (error) {
      console.error('处理自定义日期异常:', error);
    }
  }
  
  // 获取统一的数据统计
  async fetchAllStatisticsData(begin: any, end: any) {
    try {
      const response = await getStatisticsData({ begin: begin, end: end });
      if (response && response.data && response.data.code === 1 && response.data.data) {
        const data = response.data.data;
        
        // 设置营业额数据
        if (data.turnoverData) {
          this.turnoverData = {
            dateList: data.turnoverData.dateList ? data.turnoverData.dateList.split(',') : [],
            turnoverList: data.turnoverData.turnoverList ? data.turnoverData.turnoverList.split(',') : []
          };
        }
        
        // 设置用户统计数据
        if (data.userData) {
          this.userData = {
            dateList: data.userData.dateList ? data.userData.dateList.split(',') : [],
            totalUserList: data.userData.totalUserList ? data.userData.totalUserList.split(',') : [],
            newUserList: data.userData.newUserList ? data.userData.newUserList.split(',') : [],
          };
        }
        
        // 设置订单统计数据
        if (data.orderData) {
          this.orderData = {
            data: {
              dateList: data.orderData.dateList ? data.orderData.dateList.split(',') : [],
              orderCountList: data.orderData.orderCountList ? data.orderData.orderCountList.split(',') : [],
              validOrderCountList: data.orderData.validOrderCountList ? data.orderData.validOrderCountList.split(',') : [],
            },
            totalOrderCount: data.orderData.totalOrderCount || 0,
            validOrderCount: data.orderData.validOrderCount || 0,
            orderCompletionRate: data.orderData.orderCompletionRate || 0
          };
        }
        
        // 设置销量排行TOP10
        if (data.top10Data) {
          this.top10Data = {
            nameList: data.top10Data.nameList ? data.top10Data.nameList.split(',').reverse() : [],
            numberList: data.top10Data.numberList ? data.top10Data.numberList.split(',').reverse() : [],
          };
        }
        
      } else {
        console.error('获取统计数据失败:', response && response.data ? response.data.msg : '未知错误');
      }
    } catch (error) {
      console.error('获取统计数据异常:', error);
    }
  }
  
  // 获取基本数据 - 使用单独的API接口（保留向下兼容）
  init(begin: any, end: any) {
    this.$nextTick(() => {
      this.getTurnoverStatisticsData(begin, end)
      this.getUserStatisticsData(begin, end)
      this.getOrderStatisticsData(begin, end)
      this.getTopData(begin, end)
    })
  }

  // 获取营业额统计数据
  async getTurnoverStatisticsData(begin: any, end: any) {
    try {
      const data = await getTurnoverStatistics({ begin: begin, end: end });
      if (data && data.data && data.data.code === 1 && data.data.data) {
        const turnoverData = data.data.data;
        this.turnoverData = {
          dateList: turnoverData.dateList ? turnoverData.dateList.split(',') : [],
          turnoverList: turnoverData.turnoverList ? turnoverData.turnoverList.split(',') : []
        };
      } else {
        console.error('获取营业额统计数据失败:', data && data.data ? data.data.msg : '未知错误');
        this.turnoverData = { dateList: [], turnoverList: [] };
      }
    } catch (error) {
      console.error('获取营业额统计数据异常:', error);
      this.turnoverData = { dateList: [], turnoverList: [] };
    }
  }
  
  // 获取用户统计数据
  async getUserStatisticsData(begin: any, end: any) {
    try {
      const data = await getUserStatistics({ begin: begin, end: end });
      if (data && data.data && data.data.code === 1 && data.data.data) {
        const userData = data.data.data;
        this.userData = {
          dateList: userData.dateList ? userData.dateList.split(',') : [],
          totalUserList: userData.totalUserList ? userData.totalUserList.split(',') : [],
          newUserList: userData.newUserList ? userData.newUserList.split(',') : [],
        };
      } else {
        console.error('获取用户统计数据失败:', data && data.data ? data.data.msg : '未知错误');
        this.userData = { dateList: [], totalUserList: [], newUserList: [] };
      }
    } catch (error) {
      console.error('获取用户统计数据异常:', error);
      this.userData = { dateList: [], totalUserList: [], newUserList: [] };
    }
  }
  
  // 获取订单统计数据
  async getOrderStatisticsData(begin: any, end: any) {
    try {
      const data = await getOrderStatistics({ begin: begin, end: end });
      if (data && data.data && data.data.code === 1 && data.data.data) {
        const orderData = data.data.data;
        this.orderData = {
          data: {
            dateList: orderData.dateList ? orderData.dateList.split(',') : [],
            orderCountList: orderData.orderCountList ? orderData.orderCountList.split(',') : [],
            validOrderCountList: orderData.validOrderCountList ? orderData.validOrderCountList.split(',') : [],
          },
          totalOrderCount: orderData.totalOrderCount || 0,
          validOrderCount: orderData.validOrderCount || 0,
          orderCompletionRate: orderData.orderCompletionRate || 0
        };
      } else {
        console.error('获取订单统计数据失败:', data && data.data ? data.data.msg : '未知错误');
        this.orderData = {
          data: { dateList: [], orderCountList: [], validOrderCountList: [] },
          totalOrderCount: 0,
          validOrderCount: 0,
          orderCompletionRate: 0
        };
      }
    } catch (error) {
      console.error('获取订单统计数据异常:', error);
      this.orderData = {
        data: { dateList: [], orderCountList: [], validOrderCountList: [] },
        totalOrderCount: 0,
        validOrderCount: 0,
        orderCompletionRate: 0
      };
    }
  }
  
  // 获取排行数据
  async getTopData(begin: any, end: any) {
    try {
      const data = await getTop({ begin: begin, end: end });
      if (data && data.data && data.data.code === 1 && data.data.data) {
        const top10Data = data.data.data;
        this.top10Data = {
          nameList: top10Data.nameList ? top10Data.nameList.split(',').reverse() : [],
          numberList: top10Data.numberList ? top10Data.numberList.split(',').reverse() : [],
        };
      } else {
        console.error('获取排行数据失败:', data && data.data ? data.data.msg : '未知错误');
        this.top10Data = { nameList: [], numberList: [] };
      }
    } catch (error) {
      console.error('获取排行数据异常:', error);
      this.top10Data = { nameList: [], numberList: [] };
    }
  }
  
  // 获取当前选中的tab时间
  getTitleNum(data) {
    try {
      switch (data) {
        case 1:
          this.tateData = pastWeek(); // 本周
          break;
        case 2:
          this.tateData = pastMonth(); // 本月
          break;
        default:
          this.tateData = pastWeek(); // 默认获取本周数据
          break;
      }
      this.flag = data;
      console.log('选择的时间范围:', this.tateData[0], 'to', this.tateData[this.tateData.length - 1]);
      // 使用统一的API接口获取数据
      this.fetchAllStatisticsData(this.tateData[0], this.tateData[this.tateData.length - 1]);
    } catch (error) {
      console.error('处理时间范围异常:', error);
      // 出错时默认使用本周
      this.tateData = pastWeek();
      this.fetchAllStatisticsData(this.tateData[0], this.tateData[this.tateData.length - 1]);
    }
  }
}
